<template>
    <div>
    <!-- 面包屑：名称与菜单配置同步 -->
    <AppBreadcrumb :items="[{ path: 'basicData' }, { path: 'waterType' }]" />
    <!-- 阶梯 -->
    <div class="ladder">
      <i class="iconfont icon-jietitu1"></i>
      <span style="font-size: 22px; color: #656d92">{{ $t('waterType.用水类型管理') }}</span>
      <span style="margin-left: 42px; color: #7a82a6"> </span>
      <el-button style="float:right;" size="mini" @click="dialogFormVisible"><i class="iconfont icon-jiahao"></i>{{ $t('waterType.新增用水类型') }}</el-button>
    </div>
    <div class="move">
      <el-button @click="dialogFormVisible"><i class="iconfont icon-jiahao"></i>{{ $t('waterType.新增用水类型') }}</el-button>
    </div>
    <!-- table表格 -->
    <div class="tab">
      <el-card>
    <el-table :data="tableData" size=mini highlight-current-row v-loading="loading" :header-cell-style = "{background:'#987AFF'}" :height='isMobile ? 300 : 500' :element-loading-text="$t('waterType.拼命加载中')">
    <el-table-column property="name" :label="$t('waterType.用水类型')"  />
    <el-table-column property="fee_type" :label="$t('waterType.阶梯类型')">
      <template slot-scope="scope">
        <span v-if="scope.row.fee_type === 'fixed'">{{ $t('waterType.固定') }}</span>
        <span v-if="scope.row.fee_type === 'dynamic'">{{ $t('waterType.阶梯') }}</span>
      </template>
    </el-table-column>
    <el-table-column property="fixed_monthly_fee" :label="$t('waterType.月固定费')" />
    <el-table-column property="fixed_monthly_free_flow" :label="$t('waterType.月含水量')" />
    <el-table-column property="valve" :label="$t('waterType.操作')" width="150">
      <template slot-scope="scope">
        <el-button size="mini" @click="opens(scope.row)">{{ $t('waterType.删除') }}</el-button>
        <el-button size="mini" @click="Xiugai(scope.row)">{{ $t('waterType.查看') }}</el-button>
      </template>
    </el-table-column>
  </el-table>
  <!-- 分页 -->
  <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="famlis.pagenum"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="famlis.pagesize"
      :small="isMobile"
      :pager-count="isMobile ? 5 : 7"
      :layout="isMobile ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
      :total="total">
    </el-pagination>
      </el-card>
  </div>
  <!-- 添加 -->
  <div class="cycle">
    <el-dialog :title="$t('waterType.新增阶梯')" :visible.sync="dialogVisible">
      <div class="name-input">{{ $t('waterType.名称') }}：<el-input size='small' v-model.trim="LadderData.name" :placeholder="$t('waterType.用水类型')"></el-input></div>
      <div class="Fixed-fee">
        <span>{{ $t('waterType.月固定费') }}:</span>&nbsp;&nbsp;
        <el-input size='mini' v-model.trim="LadderData.fixed_monthly_fee"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>&nbsp;&nbsp;&nbsp;
        <span>{{ $t('waterType.含水量') }}:</span>&nbsp;&nbsp;
        <el-input size='mini' v-model.trim="LadderData.fixed_monthly_free_flow"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </div>
      <div class="zhu">{{ $t('waterType.注:如果输入0元则是0元') }}</div>
      <div class="tabs-tab">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="$t('waterType.平价')" name="first">
          <div class="tabs-width">
          <el-input size='mini'  v-model.trim="LadderData.step1_price" ></el-input>&nbsp;&nbsp;&nbsp;
          <span>{{ $t('waterType.元') }}/{{ $t('waterType.方') }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('waterType.月阶梯')" name="second">
          <el-form :model="ladderMonth"  >

        <el-form-item :label="$t('waterType.阶梯一') + ' : '" :label-width="formLabelWidth" >
          <el-input v-model.trim="ladderMonth.step1_limit" size="small" ></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderMonth.step1_price" size="small" ></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>

        <el-form-item :label="$t('waterType.阶梯二') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderMonth.step2_limit" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderMonth.step2_price" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>

        <el-form-item :label="$t('waterType.阶梯三') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderMonth.step3_limit" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderMonth.step3_price" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>

        <el-form-item :label="$t('waterType.阶梯四') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderMonth.step4_limit" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderMonth.step4_price" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>

        <el-form-item :label="$t('waterType.阶梯五') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderMonth.step5_limit" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderMonth.step5_price" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('waterType.年阶梯')" name="third">
          <el-form :model="ladderYear">

        <el-form-item :label="$t('waterType.阶梯一') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step1_limit" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step1_price" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>

        <el-form-item :label="$t('waterType.阶梯二') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step2_limit" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step2_price" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>

        <el-form-item :label="$t('waterType.阶梯三') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step3_limit" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step3_price" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>

        <el-form-item :label="$t('waterType.阶梯四') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step4_limit" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step4_price" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>

        <el-form-item :label="$t('waterType.阶梯五') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step5_limit" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.方') }}</span>
        </el-form-item>
        <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
          <el-input v-model.trim="ladderYear.step5_price" size="small"></el-input>&nbsp;
          <span>{{ $t('waterType.元') }}</span>
        </el-form-item>
          </el-form>
        </el-tab-pane>
        </el-tabs>
        <!-- <div class="zhu">{{ $t('waterType.注:如要添加平价，需要点击平价后则可进行输入。') }}</div> -->
      </div>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="mini" @click="addLadder"> <i class="el-icon-document"/>{{ $t('waterType.保存') }}</el-button>
  </div>
    </el-dialog>
  </div>
  <!-- 查看 -->
  <div class="cycle">
    <el-dialog :title="$t('waterType.查看详情')" :visible.sync="XialogGisible" @close='closeDialog'>
      <div class="name-input">{{ $t('waterType.名称') }}：<el-input size='small' v-model="XadderData.name"  ></el-input></div>
      <div class="Fixed-fee">
        <span>{{ $t('waterType.月固定费') }}:</span>&nbsp;&nbsp;
        <el-input size='mini' v-model="XadderData.fixed_monthly_fee" ></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>&nbsp;&nbsp;&nbsp;
        <span>{{ $t('waterType.含水量') }}:</span>&nbsp;&nbsp;
        <el-input size='mini' v-model="XadderData.fixed_monthly_free_flow" ></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </div>
      <div class="zhu">{{ $t('waterType.注:如果输入0元则是0元') }}</div>
      <div class="tabs-tab">
        <el-tabs v-model="activeSee" type="card" @tab-click="modifyClick">
        <el-tab-pane :label="$t('waterType.平价')" name="first">
          <div class="tabs-width">
          <el-input size='mini' v-model.trim="XadderData.step1_price" ></el-input>&nbsp;&nbsp;&nbsp;
          <span>{{ $t('waterType.元') }}/{{ $t('waterType.方') }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('waterType.月阶梯')" name="second" >
          <el-form :model="xadderMonth">
      <el-form-item :label="$t('waterType.阶梯一') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step1_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step1_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>

      <el-form-item :label="$t('waterType.阶梯二') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step2_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step2_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>

      <el-form-item :label="$t('waterType.阶梯三') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step3_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step3_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>

      <el-form-item :label="$t('waterType.阶梯四') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step4_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step4_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>

      <el-form-item :label="$t('waterType.阶梯五') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step5_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderMonth.step5_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('waterType.年阶梯')" name="third" >
          <el-form :model="xadderYear">
      <el-form-item :label="$t('waterType.阶梯一') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step1_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step1_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>

      <el-form-item :label="$t('waterType.阶梯二') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step2_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step2_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>

      <el-form-item :label="$t('waterType.阶梯三') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step3_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step3_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>

      <el-form-item :label="$t('waterType.阶梯四') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step4_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step4_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>

      <el-form-item :label="$t('waterType.阶梯五') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step5_limit" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.方') }}</span>
      </el-form-item>
      <el-form-item :label="$t('waterType.价格') + ' : '" :label-width="formLabelWidth">
        <el-input v-model.trim="xadderYear.step5_price" size="small"></el-input>&nbsp;
        <span>{{ $t('waterType.元') }}</span>
      </el-form-item>
          </el-form>
        </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
    
    <el-button type="primary" size="mini" @click="XddGadder" > <i class="el-icon-document"/>{{ $t('waterType.保存') }}</el-button>
    <el-button type="primary" size="mini" @click="closebtn" >{{ $t('waterType.关闭') }}</el-button>
  </div>
</el-dialog>
</div>
    </div>
</template>
<script>
function createEmptyTierSteps () {
  return {
    step1_limit: null,
    step1_price: null,
    step2_limit: null,
    step2_price: null,
    step3_limit: null,
    step3_price: null,
    step4_limit: null,
    step4_price: null,
    step5_limit: null,
    step5_price: null
  }
}
export default {
  inject: ['reload'], //  此处引入在app中定义的reload方法
  data () {
    return {
      Par: true,
      Moon: true,
      Annual: true,
      activeName: 'first',
      activeSee: 'first',
      // 修改
      XialogGisible: false,
      // 删除
      water: {
        project_id: null,
        token: null,
        water_type_id: null
      },
      // 下拉框
      value: null,
      // 添加
      LadderData: {
        fee_type: 'fixed',
        cycle: null,
        project_id: null,
        token: null,
        name: null,
        step1_limit: null,
        step1_price: null,
        step2_limit: null,
        step2_price: null,
        step3_limit: null,
        step3_price: null,
        step4_limit: null,
        step4_price: null,
        step5_limit: null,
        step5_price: null
      },
      ladderMonth: createEmptyTierSteps(),
      ladderYear: createEmptyTierSteps(),
      // 修改
      XadderData: {
        project_id: null,
        water_type_id: null,
        fee_type: 'fixed',
        cycle: null,
        token: null,
        name: null,
        step1_limit: null,
        step1_price: null,
        step2_limit: null,
        step2_price: null,
        step3_limit: null,
        step3_price: null,
        step4_limit: null,
        step4_price: null,
        step5_limit: null,
        step5_price: null
      },
      xadderMonth: createEmptyTierSteps(),
      xadderYear: createEmptyTierSteps(),
      // 添加弹框默认是否打开
      dialogVisible: false,
      // 添加的宽度
      formLabelWidth: '80px',
      famlis: {
        project_id: null,
        token: null,
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 20
      },
      // tab
      tableData: [
        {
          cycle: null,
          id: null,
          name: null,
          step1_limit: null,
          step1_price: null,
          step2_limit: null,
          step2_price: null,
          step3_limit: null,
          step3_price: null,
          step4_limit: null,
          step4_price: null,
          step5_limit: null,
          step5_price: null
        }
      ],
      // tab数据加载转圈
      loading: true,
      total: 0,
      modifytabs: null,
      isMobile: false
    }
  },
  created () {
    this.updateIsMobile()
    this.famlis.project_id = this.$store.state.print.goodsForeNo.project_id
    this.famlis.token = this.$store.state.print.goodsForeNo.token
    // 添加
    this.LadderData.project_id = this.$store.state.print.goodsForeNo.project_id
    this.LadderData.token = this.$store.state.print.goodsForeNo.token
    // 删除
    this.water.project_id = this.$store.state.print.goodsForeNo.project_id
    this.water.token = this.$store.state.print.goodsForeNo.token
    this.tabdata()
  },
  mounted () {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateIsMobile)
  },
  methods: {
    fillTierStepsFromRow (row, target) {
      for (let i = 1; i <= 5; i++) {
        target['step' + i + '_limit'] = row['step' + i + '_limit']
        target['step' + i + '_price'] = row['step' + i + '_price']
      }
    },
    resetAddTierDrafts () {
      this.ladderMonth = createEmptyTierSteps()
      this.ladderYear = createEmptyTierSteps()
    },
    buildAddPayload () {
      const payload = Object.assign({}, this.LadderData)
      if (payload.fee_type === 'dynamic') {
        if (payload.cycle === '月') {
          Object.assign(payload, this.ladderMonth)
        } else if (payload.cycle === '年') {
          Object.assign(payload, this.ladderYear)
        }
      }
      return payload
    },
    updateIsMobile () {
      this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    },
    // tabs 添加
    handleClick (tab, event) {
      console.log(tab.label)
      if (tab.label === this.$t('waterType.平价')) {
        this.LadderData.fee_type = 'fixed'
        this.LadderData.cycle = null
      }
      if (tab.label === this.$t('waterType.月阶梯')) {
        this.LadderData.fee_type = 'dynamic'
        this.LadderData.cycle = '月'
      }
      if (tab.label === this.$t('waterType.年阶梯')) {
        this.LadderData.fee_type = 'dynamic'
        this.LadderData.cycle = '年'
      }
    },
    // 查看
    modifyClick (tab) {
      console.log(tab)
      this.modifytabs = tab.label
      console.log(this.modifytabs,'modifyClick修改')
      if (this.modifytabs === this.$t('waterType.平价')) {
        this.XadderData.fee_type = 'fixed'
        this.XadderData.cycle = null
      }
      if (this.modifytabs === this.$t('waterType.月阶梯')) {
        this.XadderData.fee_type = 'dynamic'
        this.XadderData.cycle = '月'
      }
      if (this.modifytabs === this.$t('waterType.年阶梯')) {
        this.XadderData.fee_type = 'dynamic'
        this.XadderData.cycle = '年'
      }
    },
    // 查看
    Xiugai (row) {
      console.log(row, '修改')
      this.XadderData = Object.assign({}, row)
      this.xadderMonth = createEmptyTierSteps()
      this.xadderYear = createEmptyTierSteps()
      if (row.fee_type === 'dynamic' && row.cycle === '月') {
        this.fillTierStepsFromRow(row, this.xadderMonth)
      }
      if (row.fee_type === 'dynamic' && row.cycle === '年') {
        this.fillTierStepsFromRow(row, this.xadderYear)
      }
      this.XadderData.water_type_id = row.id
      this.XialogGisible = true
    },
    closebtn () {
      this.XialogGisible = false
    },
    // 修改
   
    closeDialog () {
      console.log('qqqq')
      this.reload()
    },
    // 修改保存
    XddGadder () {
      if (this.XadderData.fee_type === 'dynamic') {
        if (this.XadderData.cycle === '月') {
          Object.assign(this.XadderData, this.xadderMonth)
        } else if (this.XadderData.cycle === '年') {
          Object.assign(this.XadderData, this.xadderYear)
        }
      }
      this.XadderData.project_id = this.$store.state.print.goodsForeNo.project_id
      this.XadderData.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterType.xaterGelets(this.XadderData).then((res) => {
        if (res.data.status === 'success') {
          this.tabdata()
          this.$notify({
            title: this.$t('message.成功'),
            message: this.$t('waterType.修改成功'),
            type: 'success'
          })
          // 刷新页面 -----缺点刷线页面有延迟体验不好  -----优点就这一条代码
          // window.location.reload()
          // 刷新页面 -----缺点还需要在app页面中写代码 当前组件中return也需要引入  -----优点刷线页面没有延迟
          // this.reload()
          this.XialogGisible = false
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
    },
    // 重选
    Reselection () {
      this.resetAddTierDrafts()
    },
    // 添加保存
    addLadder () {
      this.dialogVisible = false
      const payload = this.buildAddPayload()
      this.$api.waterType.ladderadds(payload).then((res) => {
        console.log(res, '新增')
        if (res.data.status === 'success') {
          this.tabdata()
          this.$notify({
            title: this.$t('message.成功'),
            message: this.$t('waterType.添加成功'),
            type: 'success'
          })
          // 刷新页面 -----缺点刷线页面有延迟体验不好  -----优点就这一条代码
          // window.location.reload()
          // 刷新页面 -----缺点还需要在app页面中写代码 当前组件中return也需要引入  -----优点刷线页面没有延迟
          this.reload()
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
    },
    // 添加
    dialogFormVisible () {
      this.dialogVisible = true
    },
    // tab数据
    tabdata () {
      this.$api.waterType.tabdatas(this.famlis).then((res) => {
        if (res.data.status === 'success') {
          this.tableData = res.data.data
          console.log(this.tableData)
          this.total = res.data.total
          this.loading = false
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        } else if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
    },

    // tab删除
    opens (row) {
      console.log(row, 'index')
      this.water.water_type_id = row.id
      console.log(this.water.water_type_id, 'this.water.water_type_id')
      this.$confirm(('此操作将永久删除该阶梯, 是否继续?'), ('提示'), {
        confirmButtonText: this.$t('waterType.确定'),
        cancelButtonText: this.$t('waterType.取消'),
        type: 'warning',
        customClass: typeof window !== 'undefined' && window.innerWidth <= 768 ? 'mobile-delete-confirm' : ''
      }).then(() => {
        this.$api.waterType.waterDelets(this.water).then((res) => {
          console.log(res, '删除')
          if (res.data.status === 'success') {
            this.$message({
              message: this.$t('waterType.删除成功'),
              type: 'success'
            })
            this.tabdata()
          } else if (res.data.status === 'error') {
            this.$message.error(res.data.message)
          } else if (res.data.message === '用户在别处登录') {
            this.$router.push('/', this.fasinull)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('waterType.已取消删除')
        })
      })
    },
    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
      console.log(newSize, 'q')
      this.famlis.pagesize = newSize
      this.tabdata()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange (newPage) {
      console.log(newPage)
      this.famlis.pagenum = newPage
      this.tabdata()
    }
  }
}
</script>
<style lang="less" scoped>
// 面包屑
.Gnv {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  font-size: 19px;
  letter-spacing: 1px;
  //   font-family: myFont;
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 20px;
    .yai{
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }
    ::v-deep .el-breadcrumb__item{
      margin-left: 0px;
      .el-breadcrumb__inner.is-link{
        font-weight: 100;
        color: #656d92;
  }
    }
  }
}
// 阶梯
.ladder{
  // width: 1500px;
  padding: 20px 30px 30px 20px;
  i{
    color: #744dfe;
    font-size: 27px;
  }
  .el-button{
    border: 1px solid #744dfe;
    font-size: 25px;
    color: #575757;
    i{
      font-size: 27px;
      color: #744dfe;
      margin-right: 10px;
    }
  }
}
// <!-- table表格 -->
    .tab{
        padding: 0px 30px 0px 20px;
        .el-card{
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table tr{
            background-color: #F9F9F9;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        .el-pagination{
          margin-top: 5px;
          margin-bottom: 5px;
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
          background-color: #744dfe;
          color: #FFF;
        }
    }
// 添加
.el-dialog{
      .name-input{
        display: flex;
        align-items: center;
        .el-input{
          width: 160px;
        }
      }
      .Fixed-fee{
        margin-top: 20px;
        display: flex;
        align-items: center;
        .el-input{
          width: 90px;
        }
      }
      .zhu{
        margin-top: 10px;
        color: brown;
      }
      .tabs-tab{
        margin-top: 20px;
      }
      .tabs-width{
        .el-input{
          width: 100px;
        }
      }
      .el-form{
          display: flex;
          flex-wrap: wrap;
        .el-form-item{
          .el-input{
            width: 90px;
          }
        }
      }

      .dialog-footer{
        .el-button{
          background-color: #fff;
          border: 1px solid #744dfe;
          color: #575757;
          border-radius: 4px;
          font-size: 14px;
          span{
            i{
              font-size: 14px;
              margin-right: 6px;
            }
          }
        }
      }
    }
    .cycle{
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 23%;
    }
  }
  }
    .move{
      padding: 10px 10px;
        .el-button{
          background-color: #fff;
          border: 1px solid #744dfe;
          color: #575757;
          border-radius: 4px;
          font-size: 14px;
          span{
            i{
              font-size: 14px;
              margin-right: 6px;
            }
          }
        }
    }
    @media (min-width: 768px) {
    .move{
      display: none;
    }
    }
    // 移动端
    @media (max-width: 768px) {
    .Gnv{
      display: none;
    }
    .ladder{
      display: none;
    }
    .tab{
      padding: 10px 10px;
      ::v-deep .el-pagination{
        display: flex;
        justify-content: center;
        margin: 10px 0 4px;
      }
    }
    .cycle{
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 94%;
    }
  }
  }
  /* 手机端：月阶梯/年阶梯 阶梯+价格同一行 */
  .cycle{
    ::v-deep .tabs-tab{
      .el-form{
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
      }
      .el-form-item{
        width: 50%;
        margin-bottom: 6px;
        box-sizing: border-box;
      }
      .el-form-item:nth-child(2n){
        padding-left: 3px;
      }
      .el-form-item:nth-child(2n+1){
        padding-right: 3px;
      }
      .el-form-item__label{
        width: 60px !important;
        padding-right: 6px;
      }
      .el-form-item__content{
        margin-left: 60px !important;
        display: flex;
        align-items: center;
        gap: 2px;
      }
      .el-input{
        width: 100% !important;
      }
      .el-input__inner{
        padding-left: 6px;
        padding-right: 6px;
      }
      .el-form-item__content > span{
        white-space: nowrap;
        flex: 0 0 auto;
      }
    }
  }
  /* 手机端：平价输入框宽度 30%（tabs-width） */
  .cycle{
    ::v-deep .tabs-width{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 2px;
      .el-input{
        width: 40% !important;
      }
      span{
        margin-left: 0 !important;
      }
    }
  }
 ::v-deep .el-message-box{
    width: 300px;
  }
    }
</style>
